import { useEffect } from 'react'
import { applyFieldTextSize, FIELD_TEXT_SIZE_KEY, readFieldTextSize } from '../lib/fieldTextSizeStorage'

/** Apply saved field text size on load (and when storage changes in another tab). */
export function FieldTextSizeSync() {
  useEffect(() => {
    applyFieldTextSize(readFieldTextSize())

    const onStorage = (event: StorageEvent) => {
      if (event.key == null || event.key === FIELD_TEXT_SIZE_KEY) {
        applyFieldTextSize(readFieldTextSize())
      }
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  return null
}
